export const getPlantMilkPackage = newProduct => {
  const newPlantMilkPackage = {
    UPC: newProduct.UPC,
    MilkType: newProduct.MilkType,
    Flavor: newProduct.Flavor,
    Type: newProduct.Type,
    Size: newProduct.Size,
    Organic: newProduct.Organic,
    MultiPackageType: newProduct.MultiPackageType,
    Sugar: newProduct.Sugar,
    SugarCertification: newProduct.SugarCertification,
    Calcium: newProduct.Calcium,
    CalciumCertification: newProduct.CalciumCertification,
    Protein: newProduct.Protein,
    ProteinCertification: newProduct.ProteinCertification,
    VitaminA: newProduct.VitaminA,
    VitaminACertification: newProduct.VitaminACertification,
    VitaminD: newProduct.VitaminD,
    VitaminDCertification: newProduct.VitaminDCertification,
    VitaminB12: newProduct.VitaminB12,
    VitaminB12Certification: newProduct.VitaminB12Certification,
    Magnesium: newProduct.Magnesium,
    MagnesiumCertification: newProduct.MagnesiumCertification,
    Phosphorus: newProduct.Phosphorus,
    PhosphorusCertification: newProduct.PhosphorusCertification,
    Potassium: newProduct.Potassium,
    PotassiumCertification: newProduct.PotassiumCertification,
    Riboflavin: newProduct.Riboflavin,
    RiboflavinCertification: newProduct.RiboflavinCertification,
  }

  if (newProduct.MultiPackageType) {
    newPlantMilkPackage.MultiPackageCount = newProduct.MultiPackageCount
  }

  if (newProduct.MilkType === 'Other') {
    newPlantMilkPackage.OtherMilkType = newProduct.OtherMilkType
  }

  return newPlantMilkPackage
}

export const updatePlantMilkPackage = newProduct => {
  const newPlantMilkPackage = {
    UPC: newProduct.UPC,
    MilkType: newProduct.MilkType,
    Flavor: newProduct.Flavor,
    Type: newProduct.Type,
    Size: newProduct.Size,
    Organic: newProduct.Organic,
    MultiPackageType: newProduct.MultiPackageType,
    Sugar: newProduct.Sugar,
    SugarCertification: newProduct.SugarCertification,
    Calcium: newProduct.Calcium,
    CalciumCertification: newProduct.CalciumCertification,
    Protein: newProduct.Protein,
    ProteinCertification: newProduct.ProteinCertification,
    VitaminA: newProduct.VitaminA,
    VitaminACertification: newProduct.VitaminACertification,
    VitaminD: newProduct.VitaminD,
    VitaminDCertification: newProduct.VitaminDCertification,
    VitaminB12: newProduct.VitaminB12,
    VitaminB12Certification: newProduct.VitaminB12Certification,
    Magnesium: newProduct.Magnesium,
    MagnesiumCertification: newProduct.MagnesiumCertification,
    Phosphorus: newProduct.Phosphorus,
    PhosphorusCertification: newProduct.PhosphorusCertification,
    Potassium: newProduct.Potassium,
    PotassiumCertification: newProduct.PotassiumCertification,
    Riboflavin: newProduct.Riboflavin,
    RiboflavinCertification: newProduct.RiboflavinCertification,
  }

  if (newProduct.MultiPackageType) {
    newPlantMilkPackage.MultiPackageCount = newProduct.MultiPackageCount
  }

  if (newProduct.MilkType === 'Other') {
    newPlantMilkPackage.OtherMilkType = newProduct.OtherMilkType
  }

  return newPlantMilkPackage
}
